import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import DynamicSingleSideTab from "../../components/dynamicSingleSideTab/dynamicSingleSideTab";

const Configurations = () => {
  const [activeTab, setActiveTab] = useState("documents-configuration");
  const navigate = useNavigate();
  const sideNavElements = [
    { id: "documents-configuration", label: "Documents Configuration" },
    { id: "rpa-configuration", label: "RPA Configuration" },
    { id: "form-configuration", label: "Form Configuration" },
    { id: "pa-form-configuration", label: "PA Form Configuration" },
    { id: "medicine-name-configuration", label: "Medicine Name Configuration" },
    {
      id: "prescription-parsing-configuration",
      label: "Prescription Parsing Configuration",
    },
    { id: "pharma-pa-configuration", label: "Pharma PA Configuration" },
    { id: "credentials-configuration", label: "Credentials Configuration" },
    { id: "client-configuration", label: "Client Configuration" },
    { id: "health-facility", label: "Health Facility Configuration" },
    { id: "provider-list", label: "Provider Configuration" },
    { id: "payer-config", label: "Payer Configuration" },
    { id: "nar-agent-grid", label: "NAR Agent Grid" },
    { id: "nar-configuration", label: "NAR Configuration" },
    {
      id: "email-password-configuration",
      label: "Email Password Configuration",
    },
  ];

  return (
    <>
      <div className="home-container">
        <div className="home-container__content">
          <div className="home-container__content-left">
            {sideNavElements.map((sideNavElement) => (
              <DynamicSingleSideTab
                key={sideNavElement.id}
                id={sideNavElement.id}
                label={sideNavElement.label}
                isActive={activeTab === sideNavElement.id}
                onTabClick={(id: string) => {
                  setActiveTab(id);
                  navigate(id);
                }}
              />
            ))}
          </div>
          <div className="home-container__content-right">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Configurations;
